import React from "react";
export default function Independence() {
  return (
    <article className="research-card">
      <h1>Independent analysis, clear relationships.</h1>
      <p>
        Prop AI is operated by R2 Real Estate Co PTY LTD, ABN 12 695 647 762,
        directed by Uttorio Datta. Prop AI is being built to provide the same
        analysis whether you find a property through R2, another agent or your
        own research.
      </p>
      <p>
        Partner attribution is excluded from the evidence builder. This preview
        does not pass your details or report into real-estate sales or referral
        workflows. Referral remuneration arrangements are not yet confirmed.
      </p>
      <p>
        Missing evidence is shown as not assessed. We do not provide automated
        valuations, growth forecasts or investment rankings.
      </p>
      <h2>Evidence and scenarios have different roles.</h2>
      <p>
        Sourced findings retain their source, observation period and geographic
        scope. A postcode rent benchmark does not establish the rent for an
        individual home. Calculators use your inputs and confirmations; their
        results are scenarios, not valuations or forecasts.
      </p>
      <h2>A map is context, not a risk assessment.</h2>
      <p>
        A matched pin represents a council parcel centroid, not an entrance,
        building location or surveyed title boundary. The council-area outline
        shows the pilot area; it does not establish flood, planning, transport
        or amenity coverage. Missing or older evidence remains visibly
        identified.
      </p>
    </article>
  );
}
